import React from 'react';
import { connect } from "react-redux";
import { ToolBar, ToolBarGroup } from 'src/legacy/components/ToolBar/ToolBar.jsx';
import { ToolBarButtonItem } from 'src/legacy/components/ToolBar/ToolBarButtonItem.jsx';
import {trackAdoptionMetricsForBannerCroppedEvent,trackAdoptionMetricsForBannerCroppedCollectionEvent} from "src/legacy/redux/actions/adoption";
import ReactCrop from "react-image-crop";
import 'react-image-crop/dist/ReactCrop.css';
import _ from 'lodash'; 
import isEqual from 'is-equal';
import cx from 'classnames';
import styles from './styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';

class CropImageView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: this.props.src,
      crop: this.props.crop,
      percentCrop: this.props.crop,
      loading: true
    }

    this.onChange = this.onChange.bind(this);
    this.onComplete = this.onComplete.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);

    this.onDoneClicked = this.onDoneClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);

    // localized contents
    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = localizedStrings.commons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedAddBanner = localizedStrings.components.addBanner;
  }

  componentWillReceiveProps(nextProps){
    if(isEqual(this.props.crop, nextProps.crop)){
      this.setState({
        crop: nextProps.crop
      });
    }
  }

  onChange(crop){
    this.setState({
      crop: crop
    });
  }

  onImageLoaded(image){
    this.setState({
      loading: false
    })
  }

  onComplete(crop, percentCrop){
    this.setState({
      percentCrop: percentCrop
    });
  }

  onDoneClicked(){
    if(this.props.onCrop){
      this.props.onCrop(this.state.percentCrop);
    }
    
    const cta = _.get(this.props, "source", "");
    const collectionName = _.get(this.props, 'collectionName');
    var collection = cta === "Collection" ?  collectionName : "";
    
    this.props.trackAdoptionMetricsForBannerCroppedCollectionEvent(collection, "Image", _.capitalize(cta));
  
  }

  onCancelClicked(){
    if(this.props.onCancel){
      this.props.onCancel();
    }
  }

  render() {
    var style = {
      width: this.props.dimension.width
    }

    return (
      <div className={styles.editor}>
        <ToolBar>
          <ToolBarGroup direction="left">
            <ToolBarButtonItem
                className={cx(styles.action)}
                width="auto" height="auto"
                onClick={this.onDoneClicked}>
                <span className={styles.actionButton}><span className={cx("fa fa-check", styles.icon)}></span>{this.localizedAddBanner.crop.actions.done}</span>
            </ToolBarButtonItem>

            <ToolBarButtonItem
                className={cx(styles.action, styles.cancel)}
                width="auto" height="auto"
                onClick={this.onCancelClicked}>
                <span className={styles.actionButton}><span className={cx("fa fa-close", styles.icon)}></span>{this.localizedCommonActions.cancel}</span>
            </ToolBarButtonItem>
          </ToolBarGroup>
        </ToolBar>

        {this.state.loading && 
          <div className={styles.loading}>
             {this.localizedCommonLoading.loading} {this.localizedAddBanner.add_banner.options.image}...
          </div>   
        }
                  
        <div className={styles.crop} style={style}>
          <ReactCrop
            src={this.state.src}
            crop={this.state.crop}
            keepSelection={true}
            onImageLoaded ={this.onImageLoaded}
            onChange={this.onChange}
            onComplete={this.onComplete}
            className={styles.image}
            crossorigin="Anonymous"
          />
        
        </div>
      </div>  
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  return {}
};

const mapDispatchToProps = (dispatch) => {
  return {
    trackAdoptionMetricsForBannerCroppedEvent : (bannerType,cta) =>{
      return dispatch(trackAdoptionMetricsForBannerCroppedEvent(bannerType,cta));
    },
    trackAdoptionMetricsForBannerCroppedCollectionEvent:(collectionName,bannerType,cta) =>{
      return dispatch(trackAdoptionMetricsForBannerCroppedCollectionEvent(collectionName,bannerType,cta));
    }
  }

}

const CropImageViewComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CropImageView);


export default CropImageViewComponent;